const translations = {
  // Common
  loading: 'Chargement...',
  error: 'Erreur',
  success: 'Succès',
  save: 'Enregistrer',
  cancel: 'Annuler',
  delete: 'Supprimer',
  edit: 'Modifier',
  view: 'Voir',
  close: 'Fermer',
  send: 'Envoyer',
  confirm: 'Confirmer',
  search: 'Rechercher',
  filter: 'Filtrer',
  status: 'Statut',
  actions: 'Actions',
  all: 'Tous',
  name: 'Nom',
  email: 'Email',
  location: 'Ville',
  active: 'Actif',
  inactive: 'Inactif',
  more: 'plus',
  count: 'Nombre',
  overview: 'Vue d\'ensemble',
  statistics: 'Statistiques',
  errorLoadingStats: 'Erreur lors du chargement des statistiques',
  activePlans: 'Forfaits actifs',
  activityDistribution: 'Distribution des activités',
  activityMetrics: 'Métriques des activités',
  activityTrends: 'Tendances des activités',
  userMetrics: 'Métriques des utilisateurs',
  subscribers: 'Abonnés',
  averageParticipants: 'Moyenne des participants',
  totalActivities: 'Total des activités',
  upcomingActivities: 'Activités à venir',
  availability: 'Disponibilité',
  placesAvailable: 'Places disponibles',
  registerActivity: 'Confirmer l\'inscription',
  pastActivities: 'Activités passées',
  totalUsers: 'Total des utilisateurs',
  activeSubscriptions: 'Abonnements actifs',
  newsletterSubscribers: 'Abonnés à la newsletter',
  weekly: 'Hebdomadaire',
  monthly: 'Mensuel',
  category: 'Catégorie',
  yoga: 'Yoga',
  shiatsu: 'Shiatsu',
  chiNeiTsang: 'Chi Nei Tsang',
  ateliers: 'Ateliers',
  autres: 'Autres',
  topActivities: 'Top 10 des activités',
  topUsers: 'Top 10 des utilisateurs',
  userPreferences: 'Préférences des utilisateurs',
  participantsCount: 'Nombre de participants',
  activityCount: 'Nombre d\'activités',
  preferredCategory: 'Catégorie préférée',
  noAvailableSpots: 'Complet',
  introduction: 'Introduction',
  addPlan: 'Ajouter un forfait',

  //Pages
  findAndJoinActivities: 'Trouvez et rejoignez les activités qui vous intéressent',
  readyToJoin: 'Prêt à rejoindre notre communauté ?',
  joinCommunityMessage: 'Rejoignez notre communauté pour participer à des activités, rencontrer d\'autres personnes et profiter plainement de votre temps libre.',
  getStarted: 'Démarrer',
  viewDetails: 'Voir les détails',
  full: 'Complet',
  available: 'Disponible',
  discoverActivities: 'Découvrez nos activités',
  activityFull: 'Plus de places disponibles',
  registration: 'Inscription',
  userProfile: 'Profil de l\'utilisateur',
  subscription: 'Abonnement',
  activitiesRemaining: '{{remaining}}/{{max}} Activités restantes',
  errorCancelling: 'Erreur lors de la suppression de l\'inscription',
  cancellationCutoffHours: 'Les annulations sont fermées moins de {{hours}} heures avant le début du cours.',
  cancellationCutoff: 'Les annulations sont fermées moins de 3 heures avant le début du cours.',
  completed: 'Terminé',
  confirmCancel: 'Confirmer la suppression',
  keepRegistration: 'Conserver l\'inscription',
  bio: 'Biographie / Informations Générales',
  profileUpdateSuccess: 'Profil mis à jour avec succès',
  preferences: 'Préférences',
  noActiveSubscription: 'Aucun abonnement actif',
  manageSubscription: 'Gérer l\'abonnement',
  getSubscription: 'Obtenir un abonnement',
  durationMinutes: '{{minutes}} minutes',
  newsletterSubscribed: 'Vous êtes abonné à notre newsletter',
  newsletterNotSubscribed: 'Vous n\'êtes pas abonné à notre newsletter',
  unsubscribe: 'Se désinscrire',
  browseActivities: 'Parcourir les activités',
  myActivities: 'Mes activités',
  myActivitiesDescription: 'Consultez et gérez vos activités réservées',
  loginToRegister: 'Veuillez vous connecter pour vous inscrire à cette activité',
  welcomeBack: 'Heureuse de vous revoir !',
  loginToAccess: 'Identifiez-vous pour accéder au Planning',
  noAccount: 'Pas encore de compte ?',
  createAccount: 'Créer un compte',
  registerToSchedule: 'Inscrivez-vous pour planifier votre activité',
  alreadyHaveAccount: 'Vous avez déjà un compte ?',
  confirmRegistration: 'Confirmer l\'inscription',
  confirmRegistrationMessage: 'Êtes-vous sûr de vouloir vous inscrire à cette activité ?',
  alreadyRegistered: 'Vous êtes déjà inscrit à cette activité',
  userManagement: 'Gestion des utilisateurs',
  newsletters: 'Abonnés à la newsletter',
  activity: 'Activités',
  participants: 'Participants',
  recentActivities: 'Activités récentes',
  recentUsers: 'Utilisateurs récents',
  addUser: '+ Ajouter un utilisateur',
  basicInformation: 'Informations Générales',
  activitiesManagement: 'Gestion des activités',
  maxActivities: 'Nombre maximum d\'activités',
  susbcriptionStatus: 'Statut de l\'abonnement',
  add: 'Ajouter',
  createNewsletter: 'Créer une newsletter',
  sendDate: 'Date d\'envoi',
  sendNow: 'Envoyer maintenant',
  planManagement: 'Gestion des forfaits',
  noActivities: 'Aucune activité sur cette semaine',
  activityPast: 'Activité passée',
  loginFailed: 'Identifiants invalides ou mot de passe incorrect',
  create: 'Créer une activité',
  confirmDelete: 'Êtes-vous sûr de vouloir supprimer cette activité ?',
  confirmUnregistration: 'Êtes-vous sûr de vouloir vous désinscrire de cette activité ?',
  confirmUnregistrationMessage: 'Vous êtes sur le point de vous désinscrire.',
  newsletter: 'Newsletter',
  enterNewPassword: 'Entrez votre nouveau mot de passe',
  newPassword: 'Nouveau mot de passe',
  resetLinkSent: 'Un lien de réinitialisation a été envoyé à votre email',
  resetPasswordError: 'Erreur lors de la réinitialisation du mot de passe',
  passwordsMustMatch: 'Les mots de passe doivent correspondre',
  passwordSuccessfullyReset: 'Mot de passe réinitialisé avec succès',
  required: 'Requis',
  invalidEmail: 'Email invalide',
  noUpcomingActivities: 'Aucune activité à venir',
  noPastActivities: 'Aucune activité passée',
  profileInformation: 'Informations du profil',
  updateProfile: 'Mettre à jour le profil',
  security: 'Sécurité',
  changePassword: 'Changer le mot de passe',
  currentPassword: 'Mot de passe actuel',
  newPasswordConfirmation: 'Confirmation du nouveau mot de passe',
  updatePassword: 'Mettre à jour le mot de passe',
  updatePasswordSuccess: 'Mot de passe mis à jour avec succès',
  receiveNewsletter: 'Recevoir la newsletter',
  fullName: 'Prénom et nom',
  deleteUserConfirmation: 'L\'utilisateur n\'aura plus accès à son compte.',
  userDetails: 'Détails de l\'utilisateur',
  basicInfo: 'Informations',
  role: 'Rôle',
  subscriptionStatus: 'Statut de l\'abonnement',
  noRecentActivities: 'Aucune activité récente',
  noFutureActivities: 'Aucune activité à venir',
  userDeletedSuccessfully: 'Utilisateur supprimé avec succès',
  registrationFailed: 'Erreur lors de l\'inscription',
  passwordChangeError: 'Erreur lors de la modification du mot de passe',
  participantsList: 'Liste des participants',
  registeredAt: 'Inscrit le',
  passwordResetSuccess: 'Mot de passe réinitialisé avec succès',
  passwordResetError: 'Erreur lors de la réinitialisation du mot de passe',
  errorModifyingParticipants: 'Erreur lors de la modification du nombre de participants',
  editUser: 'Modifier l\'utilisateur',

  // Navigation
  backToHome: 'Retour à l\'accueil',
  home: 'Accueil',
  activities: 'Planning des Activités',
  activitiesTitle: 'Planning des Activités',
  activitiesDescription: 'Planifiez vos activités en toute simplicité avec notre calendrier',
  subscriptions: 'Abonnements',
  contact: 'Contact',
  profile: 'Profil',
  admin: 'Administration',
  dashboard: 'Tableau de bord',
  noParticipants: 'Aucun participant',
  viewParticipants: 'Voir les participants',
  numberOfParticipants: 'Nombre de participants',
  useSubscription: 'Utiliser l\'abonnement',
  availableSpots: 'Places disponibles',
  confirmRegistrationText: 'Êtes-vous sûr de vouloir vous inscrire à cette activité ?',
  willDecrease: "Le nombre d'activités disponibles diminuera de",
  Participants: 'Participants',

  // Authentication
  login: 'Connexion',
  logout: 'Déconnexion',
  register: 'Inscription',
  password: 'Mot de passe',
  forgotPassword: 'Mot de passe oublié ?',
  resetPassword: 'Réinitialiser le mot de passe',
  confirmPassword: 'Confirmer le mot de passe',
  firstName: 'Prénom',
  lastName: 'Nom',
  phone: 'Téléphone',
  passwordRequirements: 'Les exigences de mot de passe sont les suivantes :',
  subscribeNewsletter: 'S\'abonner à la newsletter',
  sendResetLink: 'Envoyer le lien de réinitialisation',
  enterEmailForReset: 'Entrez votre email pour réinitialiser votre mot de passe',
  phoneNumberFormat: 'Format du numéro de téléphone',
  phoneNumber: 'Numéro de téléphone',

  // Categories
  categories: 'Catégories',
  allCategories: 'Toutes les catégories',

  // Plans/Subscriptions
  plans: 'Forfaits',
  choosePlan: 'Choisissez votre forfait',
  planName: 'Nom du forfait',
  description: 'Description',
  price: 'Prix',
  duration: 'Durée',
  validityPeriod: 'Période de validité',
  subscribe: 'S\'abonner',
  subscriptionDetails: 'Détails de l\'abonnement',
  months: 'mois',
  minutes: 'minutes',
  hours: 'heures',
  selectPlanMessage: 'Voici les différents forfaits disponibles à la yourte. Me contacter pour plus d\'informations.',
  confirmSubscription: 'Confirmer l\'abonnement',
  confirmSubscriptionMessage: 'Êtes-vous sûr de vouloir vous abonner à ce forfait ?',

  // Activities Management
  activityManagement: 'Gestion des activités',
  activityTypeManagement: 'Types d\'activités',
  addActivity: 'Ajouter une activité',
  editActivity: 'Modifier l\'activité',
  deleteActivity: 'Supprimer l\'activité',
  title: 'Titre',
  shortDescription: 'Description courte',
  date: 'Date',
  time: 'Heure',
  maxParticipants: 'Participants maximum',
  durationHelp: 'Durée en minutes',
  locationName: 'Nom du lieu',
  address: 'Adresse',
  city: 'Ville',
  featured: 'Mis en avant',
  repeatWeekly: 'Répéter chaque semaine',
  upcoming: 'À venir',
  past: 'Passé',
  week: 'Semaine',
  today: 'Aujourd\'hui',
  previous: 'Précédent',
  next: 'Suivant',
  unregisterActivity: 'Se désinscrire de l\'activité',
  confirmUnregistrationText: 'Vous etes sur le point d\'annuler cette inscription à l\'activité',
  noActivitiesInRange: 'Aucune activité dans cette période',
  spotsLeft: '{{count}} places restantes',
  participantsCount: '{{current}}/{{max}} participants',
  currentParticipants: 'Participants actuellement',
  newNumberOfParticipants: 'Nouveau nombre de participants',
  modifyParticipantsNote: 'Vous avez actuellement {{count}} participants inscrits',
  confirmCancelRegistrationText: 'Vous etes sur le point d\'annuler cette inscription à l\'activité',
  errorFetchingParticipants: 'Erreur lors de la récupération des participants',
  today: 'Aujourd\'hui',
  tomorrow: 'Demain',
  previousDay: 'Avant',
  nextDay: 'Après',
  listView: 'Liste',
  calendarView: 'Calendrier',

  // Activity Registration
  unregister: 'Se désinscrire',
  cancelRegistration: 'Annuler l\'inscription',
  confirmCancelRegistration: 'Êtes-vous sûr de vouloir annuler votre inscription ?',
  registrationSuccess: 'Inscription réussie',
  registrationError: 'Erreur lors de l\'inscription',
  noRegisteredActivities: 'Aucune activité enregistrée',
  remainingActivities: '{{remaining}}/{{max}} Activités restantes',
  joined: 'Rejoint',
  activityNotFound: 'Activité non trouvée',
  registerUserForActivity: 'Inscrire un utilisateur pour une activité',
  numberOfParticipantsHelper: 'Nombre de participants',
  registrationSuccessful: 'Inscription réussie',
  modifyParticipants: 'Modifier le nombre de participants',
  agendaView: 'Vue Agenda',
  loginToSeeMore: 'Veuillez vous connecter pour vous inscrire à cette activité',
  detailedDescription: 'Description détaillée',
  viewSchedule: 'Voir les sessions programmées',
  treatmentType: 'Type de Soins',

  // Newsletter Management
  newsletterManagement: 'Gestion des newsletters',
  subject: 'Sujet',
  content: 'Contenu',
  draft: 'Brouillon',
  sent: 'Envoyé',
  scheduledDate: 'Date d\'envoi',
  recipients: 'Destinataires',
  preview: 'Aperçu',
  saveAsDraft: 'Enregistrer en brouillon',
  subscriberCount: 'Nombre de destinataires',
  created: 'Créé le',
  notSent: 'Non envoyé',
  confirmSend: 'Confirmer l\'envoi',
  confirmSendMessage: 'Êtes-vous sûr de vouloir envoyer cette newsletter ?',
  newsletterUpdateError: 'Erreur lors de la mise à jour de la newsletter',
  newsletterSubscribeSuccess: 'Vous êtes abonné à la newsletter',

  // Error Messages
  errorLoading: 'Erreur lors du chargement',
  errorSaving: 'Erreur lors de l\'enregistrement',
  errorDeleting: 'Erreur lors de la suppression',
  errorInvalidImageType: 'Type d\'image invalide',
  errorFetchingActivities: 'Erreur lors de la récupération des activités',
  errorFetchingImages: 'Erreur lors de la récupération des images',
  newsletterUnsubscribeSuccess: 'Vous êtes désinscrit de la newsletter',

  // Success Messages
  saveSuccess: 'Enregistré avec succès',
  deleteSuccess: 'Supprimé avec succès',
  updateSuccess: 'Mis à jour avec succès',

  // Filters
  filters: 'Filtres',
  resetFilters: 'Réinitialiser les filtres',
  
  // Image Management
  uploadImage: 'Télécharger une image',
  selectFromGallery: 'Sélectionner depuis la galerie',
  selectImage: 'Sélectionner une image',

  // Calendar Views
  calendarView: 'Vue du calendrier',
  monthView: 'Par mois',
  weekView: 'Par semaine',
  dayView: 'Par jour',
  monthActivities: 'Activités du mois',
  weekActivities: 'Activités de la semaine',
  dayActivities: 'Activités du jour',
  today: 'Aujourd\'hui',
  previous: 'Précédent',
  next: 'Suivant',
  activityCalendar: 'Calendrier des activités',
  searchActivity: 'Rechercher une activité',
  day: 'Jour',
  time: 'Heure',
  all: 'Toutes les catégories',
  activityTitleDistribution: 'Distribution des titres d\'activités',
  yearly: 'Annuel',

  // Activity categories
  'yoga ashtanga': 'Yoga Ashtanga',
  'yoga vinyasa': 'Yoga Vinyasa',
  'yoga restauratif': 'Yoga Restauratif',
  'yin yoga': 'Yin Yoga',
  'yoga des énergies': 'Yoga des Énergies',
  'pilates doux': 'Pilates Doux',
  'power pilates': 'Power Pilates',
  'shiatsu': 'Shiatsu',
  'chi nei tsang': 'Chi Nei Tsang',
  'ateliers': 'Ateliers',
  'autres': 'Autres',
  'soin': 'Soin',
  // Statistics labels
  'statistics': 'Statistiques',
  'overview': 'Vue d\'ensemble',
  'activities': 'Activités',
  'users': 'Utilisateurs',
  'activityDistribution': 'Distribution des activités',
  'activityStats': 'Statistiques des activités',
  'activityTrends': 'Tendances des activités',
  'userTrends': 'Tendances des utilisateurs',
  'category': 'Catégorie',
  'total': 'Total',
  'percentage': 'Pourcentage',
  'totalUsers': 'Utilisateurs totaux',
  'activeUsers': 'Utilisateurs actifs',
  'weekly': 'Hebdomadaire',
  'monthly': 'Mensuel',
  'yearly': 'Annuel',
  'errorLoadingStats': 'Erreur lors du chargement des statistiques',

  // User Bookings
  'userBookings': 'Réservations par utilisateur',
  'totalBookings': 'Total des réservations',

  // New translations for anonymous users and missing email
  'anonymous': 'Anonyme',
  'noEmail': 'Pas d\'email',

  // New translations for capacity and usage statistics
  'totalCapacity': 'Capacité totale',
  'usedCapacity': 'Capacité utilisée',
  'unusedCapacity': 'Capacité inutilisée',
  'totalAvailableSpots': 'Places totales disponibles',
  'totalBookedSpots': 'Places réservées',
  'totalUnusedSpots': 'Places non utilisées',
  'capacityByCategory': 'Capacité par catégorie',
  'usagePercentage': 'Taux d\'utilisation',
  'availableSpots': 'Places disponibles',
  'unusedSpots': 'Places non utilisées',
  'remainingActivities': 'Activités restantes',
  'averageUsage': 'Utilisation moyenne',
  'registered': 'Inscrit',
  'attended': 'Présent',
  'cancelled': 'Annulé',
}

export default translations; 